import React from "react";
import { primaryTextColorOppositeShade } from "../../utils/constants";

export default function StatusInfoIcon({ color = primaryTextColorOppositeShade }) {
  return (
    <svg
      id="_005-info"
      data-name="005-info"
      xmlns="http://www.w3.org/2000/svg"
      width="19.227"
      height="19.227"
      viewBox="0 0 19.227 19.227"
    >
      <path
        id="Pfad_2"
        data-name="Pfad 2"
        d="M9.613,19.227A9.613,9.613,0,1,0,0,9.613,9.634,9.634,0,0,0,9.613,19.227Zm0-18.1A8.487,8.487,0,1,1,1.127,9.613,8.5,8.5,0,0,1,9.613,1.127Z"
        fill={color}
      />
      <path
        id="Pfad_3"
        data-name="Pfad 3"
        d="M67.36,74.72A7.36,7.36,0,1,0,60,67.36,7.39,7.39,0,0,0,67.36,74.72Zm0-13.594a6.234,6.234,0,1,1-6.234,6.234A6.241,6.241,0,0,1,67.36,61.127Z"
        transform="translate(-57.747 -57.747)"
        fill={color}
      />
      <path
        id="Pfad_4"
        data-name="Pfad 4"
        d="M212.69,124.38a1.69,1.69,0,1,0-1.69-1.69A1.692,1.692,0,0,0,212.69,124.38Zm0-2.253a.563.563,0,1,1-.563.563A.564.564,0,0,1,212.69,122.127Z"
        transform="translate(-203.077 -116.456)"
        fill={color}
      />
      <path
        id="Pfad_5"
        data-name="Pfad 5"
        d="M181.563,242.127h.563v3.98a.563.563,0,0,0,.563.563h2.253a.563.563,0,0,0,.563-.563v-4.544a.563.563,0,0,0-.563-.563h-3.38a.563.563,0,0,0,0,1.127Zm2.816,3.417h-1.127v-3.417h1.127Z"
        transform="translate(-174.203 -231.95)"
        fill={color}
      />
    </svg>
  );
}
